import React, { Dispatch, ReactNode, SetStateAction, useState } from 'react';

interface Initial {
  errors?: ErrorStates;
  setErrors: Dispatch<SetStateAction<ErrorStates | undefined>>;
}

interface ErrorStates {
  messages?: string[];
  meals?: string;
  unknown?: string;
}

interface Props {
  children: ReactNode | ReactNode[];
}

export const ErrorContext = React.createContext<Initial>({} as Initial);

export const ErrorProvider: React.FC<Props> = ({ children }) => {
  const [errors, setErrors] = useState<ErrorStates | undefined>(undefined);
  return <ErrorContext.Provider value={{ errors, setErrors }}>{children}</ErrorContext.Provider>;
};
